import { render, staticRenderFns } from "./CancelamentoNotaFiscal.vue?vue&type=template&id=0bb34828&scoped=true&"
import script from "./CancelamentoNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./CancelamentoNotaFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb34828",
  null
  
)

export default component.exports